import { products } from '@/data/products'
import { SITE_NAME, SITE_TAGLINE, absoluteUrl } from './siteConfig'

// JSON-LD blocks for the marketing home page. Crawlers and AI assistants read
// these to understand the brand and the product catalog.

const organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: absoluteUrl('/'),
  logo: absoluteUrl('/favicon.svg'),
  description: `${SITE_NAME} — ${SITE_TAGLINE}. Proactive remote monitoring, fall detection, and continuous vitals for geriatric care.`,
  // sameAs: fill with real social profile URLs when available
  sameAs: [] as string[],
}

const website = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: absoluteUrl('/'),
}

const productCatalog = {
  '@context': 'https://schema.org',
  '@type': 'OfferCatalog',
  name: `${SITE_NAME} Products`,
  url: absoluteUrl('/'),
  itemListElement: products.map((p) => ({
    '@type': 'Product',
    name: p.name,
    description: p.description,
    category: p.category,
    offers: {
      '@type': 'Offer',
      priceCurrency: 'USD',
      price: p.price,
      availability: 'https://schema.org/InStock',
      ...(p.type === 'recurring' ? { eligibleCustomerType: 'https://schema.org/Subscription' } : {}),
    },
  })),
}

export const homeJsonLd = [organization, website, productCatalog]

/**
 * WebPage + BreadcrumbList for an inner page (legal, etc.). Per COMPLIANCE §4 —
 * gives crawlers and AI assistants a clean machine-readable page identity.
 */
export function pageJsonLd(opts: { path: string; name: string; description: string }) {
  const url = absoluteUrl(opts.path)
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: opts.name,
      description: opts.description,
      url,
      isPartOf: { '@type': 'WebSite', name: SITE_NAME, url: absoluteUrl('/') },
      publisher: { '@type': 'Organization', name: SITE_NAME, url: absoluteUrl('/') },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: absoluteUrl('/') },
        { '@type': 'ListItem', position: 2, name: opts.name, item: url },
      ],
    },
  ]
}
